<template>
  <UiToasts />
</template>
<script setup lang="ts"></script>
<style lang="sass" scoped></style>
